import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import GUI from "lil-gui";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { GroundedSkybox } from "three/examples/jsm/objects/GroundedSkybox.js";
import gsap from "gsap";
import { functionLibrary } from "./functions.js";

import { HOTSPOTSDATA, HOTSPOTICONTYPE } from "./hotspotsData.js";
import CONFIGDATA from "./configuration.js";
import 'fslightbox'
// let CONFIGDATA = null, HOTSPOTSDATA = null

// fetch("http://localhost:3000/api/configuration/latest")
//   .then((response) => {
//     return response.json()
//   })
//   .then((json) => {
//     CONFIGDATA = json[0]
//     HOTSPOTSDATA = json[0].hotspots.hotspotData
//     console.log(HOTSPOTSDATA);
//     console.log(CONFIGDATA);
//     LoadDataFromConfig.initConfig()
//   });

// Default theme
import "@splidejs/splide/css";

// or other themes
import "@splidejs/splide/css/skyblue";
import Splide from "@splidejs/splide";

import Stats from "stats.js";

// var stats = new Stats();
// stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom);

window.mobileAndTabletCheck = function () {
	let check = false;
	(function (a) {
		if (
			/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
				a
			) ||
			/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
				a.substr(0, 4)
			)
		)
			check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
};

const isMobile = navigator.userAgentData?.mobile;

/**
 * Debug
 */

// const gui = new GUI()

/**
 * GLOBALS
 */

let heroProduct,
	hotspotsArr = [],
	hotspotsVisible = false,
	lastScaledObj,
	pointerScale,
	intersectionPoint,
	isThreeJsPointerEventsEnabled = true,
	raycastArray = [],
	modelsLoaded = false,
	isHeroAnimationPlaying = false,
	heroAnimationDirection = "forward",
	skybox,
	modelViewer,
	arBtn,
	controls,
	clips,
	mixer,
	colorMat = [],
	xRayMats = [],
	isXRayOn = false;

	
let ii = 1
const loadingAnimInterval = setInterval(() => {
	document.getElementById('loader-para').innerHTML = ''
	document.getElementById('loader-para').innerHTML = '.'.repeat(ii)
	ii++
	if(ii > 3)
		ii = 1
}, 1000);

const controlOptionsDiv = document.querySelector("#controlOptions");
const closeLeadGenForm = document.querySelector("#closeLeadGenForm");
const closeProductDataModal = document.querySelector("#closeProductData");
const controlsPanel = document.querySelector("#controlsPanel");

const hotspotIconScaleTo = 1.5,
	hotspotIconScaleFrom = 1;

const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();

//For configuration

let hotspotIconType = "default";
if (HOTSPOTICONTYPE) hotspotIconType = HOTSPOTICONTYPE;

const GLOBALS = {
	floorColor: "#525252",
	curtainColor: "#5c5c5c",
};
const params = {
	threshold: 0.05,
	strength: 0.12,
	radius: 0.2,
	exposure: 0.1,
	height: 15,
	radiusSkybox: 100,
};

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();
// scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );

//Groups

const productGroup = new THREE.Group();
scene.add(productGroup);

/**
 *  Texture
 */

const textureLoader = new THREE.TextureLoader();
const cubeTextureLoader = new THREE.CubeTextureLoader();

const matcapTexture = textureLoader.load("./textures/matcaps/1.png");

matcapTexture.colorSpace = THREE.SRGBColorSpace;

/**
 * Environment map
 */

/**
 * Physics
 */

/**
 * Floor Object
 */

// const floorGeometry = new THREE.PlaneGeometry( 10, 10 );
const floorGeometry = new THREE.CircleGeometry(5, 32);
const floorMaterial = new THREE.MeshStandardMaterial();
const floor = new THREE.Mesh(floorGeometry, floorMaterial);
floor.receiveShadow = true;
floor.rotation.x = -Math.PI / 2;

// floor.receiveShadow = true
// scene.add( floor );

// Floor controls

// gui.add(floor.position, 'y').name( 'Floor elevation' ).min(-1).max(1).step(0.01)
// gui.addColor(floorMaterial, 'color').name( 'Floor Colour')

/**
 * Curtain Object
 */

// const curtainGeometry = new THREE.SphereGeometry( 15, 32, 16 );
const curtainGeometry = new THREE.BoxGeometry(50, 50, 50);
const curtainMaterial = new THREE.MeshLambertMaterial({
	color: GLOBALS.curtainColor,
	side: THREE.BackSide,
});
const backgroundColorLayer = new THREE.Mesh(curtainGeometry, curtainMaterial);
backgroundColorLayer.position.z = -10;

// gui.addColor(curtainMaterial, 'color').name('Background Colour')

/**
 * Sizes
 */
const sizes = {
	width: window.innerWidth,
	height: window.innerHeight,
};

/**
 * Window resize
 */
const windowOnResize = () => {
	sizes.width = window.innerWidth;
	sizes.height = window.innerHeight;
	camera.aspect = sizes.width / sizes.height;
	camera.updateProjectionMatrix();

	renderer.setSize(sizes.width, sizes.height);
};

window.addEventListener("resize", windowOnResize);

window.addEventListener("dblclick", () => {
	const fullscreenElement =
		document.fullscreenElement || document.webkitFullscreenElement;

	if (!fullscreenElement) {
		if (canvas.requestFullscreen()) {
			canvas.requestFullscreen();
		} else if (canvas.webkitRequestFullscreen()) {
			canvas.webkitRequestFullscreen();
		}
	} else {
		if (document.exitFullscreen()) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen()) {
			document.webkitExitFullscreen();
		}
	}
});

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height);
camera.position.z = 2.75;
camera.position.y = .15;
scene.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
	canvas: canvas,
	antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
if (!isMobile) {
	renderer.shadowMap.enabled = true;
	renderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap
}
renderer.render(scene, camera);
renderer.toneMappingS;

/**
 * Frame by frame rendering
 */

const clock = new THREE.Clock();
let oldElapsedTime = 0;

const tick = () => {
	const elapsedTime = clock.getElapsedTime();
	const deltaTime = elapsedTime - oldElapsedTime;

	// stats.begin()

	if (isHeroAnimationPlaying) mixer.update(deltaTime);

	if (hotspotsArr.length > 1) {
		for (let index = 0; index < hotspotsArr.length; index++) {
			const element = hotspotsArr[index];
			element.lookAt(camera.position);
		}
	}

	renderer.render(scene, camera);
	// updateAnimation()

	controls.update();
	// composer.render();
	// ...

	oldElapsedTime = elapsedTime;
	// stats.end()
	// if (document.hasFocus()) {
	// }
	window.requestAnimationFrame(tick);
};

// const updateAnimation = () => {
//     const elapsedTime = clock.getElapsedTime()
//     const deltaTime = elapsedTime - oldElapsedTime

//     if(heroProduct) {
//         // heroProduct.position.copy(sphereBody.position)
//     }
// }

/**
 * Raycasting & Pointer events
 */

Array.prototype.remove = function (v) {
	if (this.indexOf(v) != -1) {
		this.splice(this.indexOf(v), 1);
		return true;
	}
	return false;
};

//Pointer controls setup
function onPointerMove(event) {
	if (!isThreeJsPointerEventsEnabled) return;

	// calculate pointer position in normalized device coordinates
	// (-1 to +1) for both components
	pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
	pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;

	raycaster.setFromCamera(pointer, camera);

	// calculate objects intersecting the picking ray
	const intersects = raycaster.intersectObjects(raycastArray);

	if (intersects.length > 0) {
		const obj = intersects[0].object;
		intersectionPoint = intersects[0];
		lastScaledObj = obj;
		pointerScale = gsap.timeline();
		pointerScale.to(
			obj.scale,
			{
				x: hotspotIconScaleTo,
				y: hotspotIconScaleTo,
				z: hotspotIconScaleTo,
				duration: 0.25,
			},
			"<"
		);
	} else {
		if (lastScaledObj) {
			if (lastScaledObj.scale.x != 1) {
				pointerScale = gsap.timeline({
					onComplete: function () {
						lastScaledObj = null;
					},
				});
				pointerScale.to(
					lastScaledObj.scale,
					{
						x: hotspotIconScaleFrom,
						y: hotspotIconScaleFrom,
						z: hotspotIconScaleFrom,
						duration: 0.25,
					},
					"<"
				);
			}
		}
	}
}

function onPointerDown(event) {
	if (!isThreeJsPointerEventsEnabled) return;
}

function onPointerUp(params) {
	if (!isThreeJsPointerEventsEnabled) return;

	if (lastScaledObj) {
		ControlPanelFunctions.hotspotOnClick(lastScaledObj, intersectionPoint);
	}
	// raycaster.setFromCamera( pointer, camera );

	// // calculate objects intersecting the picking ray
	// const intersects = raycaster.intersectObjects( hotspotsArr );
	// if(intersects.length > 0) {

	// }
}

/**
 * GSAP Animations
 */

const GsapAnimations = {
	animateOpacity: function animateOpacity(
		ele,
		from,
		to,
		finalTransparency,
		fromVisible,
		toVisible
	) {
		const mat = ele.material;
		const eleScale = gsap.timeline({
			repeat: 0,
			onComplete: function () {
				mat.transparency = finalTransparency;
				ele.visible = toVisible;
			},
			onUpdate: function () {
				controls.update();
			},
			onStart: function () {
				ele.visible = true;
				mat.transparent = true;
			},
		});
		eleScale.fromTo(
			mat,
			{
				opacity: from,
			},
			{
				opacity: to,
				duration: 0.25,
			}
		);
	},

	animateCameraToPoint: function animateCameraToPoint(intersect) {
		const worldPosition = new THREE.Vector3();
		const pos = intersect.getWorldPosition(worldPosition);
		const camDistance = 2;
		const newPos = pos.normalize().multiplyScalar(camDistance);

		const tl1 = gsap.timeline({
			repeat: 0,
			onComplete: function () {
				controls.enabled = true;
			},
			onStart: function () {
				controls.enabled = false;
			},
			onUpdate: function () {
				camera.updateProjectionMatrix();
				controls.update();
			},
		});
		tl1.to(
			camera.position,
			{
				x: newPos.x,
				y: newPos.y,
				z: newPos.z,
				duration: 1.5,
				delay: 0,
				ease: "sine.inOut",
			},
			"<"
		);
	},
	animateToggleSize: function animateToggleSize(ele, isOpen) {
		const gsapAnimTottle = gsap.timeline({
			repeat: 0,
			onComplete: function () {
				// ele.classList.add('active')
			},
			onStart: function () { },
			onUpdate: function () { },
		});

		if (isOpen) {
			gsapAnimTottle
				.to(ele.querySelector("p"), {
					opacity: 0,
					duration: 0.3,
					delay: 0,
					ease: "none",
				})
				.to(ele.querySelector("p"), {
					width: "0",
					duration: 0.2,
					delay: 0.2,
					ease: "none",
				});
		} else {
			gsapAnimTottle
				.to(ele.querySelector("p"), {
					width: "auto",
					duration: 0.2,
					delay: 0,
					ease: "none",
				})
				.to(ele.querySelector("p"), {
					opacity: 1,
					duration: 0.2,
					delay: 0.2,
					ease: "none",
				});
		}
	},
	animateControlPanelMain: function animateControlPanelMain(ele, controlVar) {
		const className = ele.className[0];
		const parent = ele.parentElement;
		const parentId = parent.id;
		const mainOptions = parent.querySelector(".control-main-options");
		let timelineShow = null,
			timelineHide = null;

		const showOptions = () => {
			timelineShow = gsap.timeline({
				repeat: 0,
				onComplete: function () {
					ele.classList.add("active");
				},
				onStart: function () { },
				onUpdate: function () { },
			});
			timelineShow
				.to(mainOptions, {
					opacity: 1,
					// maxHeight: 500,
					// marginTop: 15,
					translateY: 0,
					pointerEvents: "all",
					duration: 0.25,
					delay: 0,
					ease: "none",
				})
				.to("#" + parentId + " .btn-option", {
					opacity: 1,
					maxHeight: 200,
					pointerEvents: "all",
					duration: 0.2,
					delay: 0.1,
					ease: "none",
				});
		};

		const hideOptions = (showCurrrentClicked) => {
			timelineHide = gsap.timeline({
				repeat: 0,
				onComplete: function () {
					const toggleEles = document.querySelectorAll(".btn-main-toggle");
					toggleEles.forEach((element) => {
						element.classList.remove("active");
					});
					if (showCurrrentClicked) {
						showOptions();
						ele.classList.add("active");
					}
				},
			});
			timelineHide
				.to(".btn-option", {
					// marginTop: 0,
					// marginBottom: 0,
					// marginLeft: 0,
					// maxHeight: 0,
					opacity: 0,
					pointerEvents: "none",
					duration: 0.2,
					delay: 0,
					ease: "none",
				})
				.to(".control-main-options", {
					opacity: 0,
					// maxHeight: 0,
					// marginTop: 0,
					pointerEvents: "none",
					duration: 0.25,
					delay: 0,
					ease: "none",
				});
		};

		if (controlVar == "reverse") {
			hideOptions(false);
			ele.classList.remove("active");
		}

		if (controlVar == "reverseAndShow") {
			hideOptions(true);
		}
	},

	toggleTickerTimer: function toggleTickerTimer() {
		const tickerEles = document.querySelectorAll("#infoTicker .container p");
		let i = -1;

		if (tickerEles > 0) {
			setInterval(() => {
				if (tickerEles[i]) tickerEles[i].classList.remove("active");

				i++;
				if (i == tickerEles.length) i = 0;

				tickerEles[i].classList.add("active");
			}, 5000);
		}
	},
};

/**
 * Create Hotspots
 */

const HOTSPOTS = {
	createAnnotations: function createAnnotations() {
		const geometry = new THREE.PlaneGeometry(0.175, 0.175);
		// const geometry = new THREE.PlaneGeometry(0.6, 0.3);
		for (let index = 0; index < HOTSPOTSDATA.length; index++) {
			const element = HOTSPOTSDATA[index];
			let texture;
			if (hotspotIconType == "individual") {
				texture = new THREE.TextureLoader().load(
					"./featureIcons/" + element.iconImageName + ".png"
				);
				texture.colorSpace = THREE.SRGBColorSpace;
			} else {
				texture = new THREE.TextureLoader().load(
					"./featureIcons/information.png"
				);
				texture.colorSpace = THREE.SRGBColorSpace;
			}
			const material = new THREE.MeshBasicMaterial({
				map: texture,
				transparent: true,
				side: THREE.DoubleSide,
			});
			const icon = new THREE.Mesh(geometry, material);
			icon.position.set(
				element.position.x,
				element.position.y,
				element.position.z
			);
			icon.name = element.name;
			icon.userData = element;
			icon.visible = false;
			hotspotsArr.push(icon);
			productGroup.add(icon);
		}
	},

	toggleHotspots: function toggleHotspots(ele) {
		for (let index = 0; index < hotspotsArr.length; index++) {
			const element = hotspotsArr[index];
			if (hotspotsVisible) {
				//Make them disappear
				raycastArray.remove(element);
				GsapAnimations.animateOpacity(element, 1, 0, true, true, false);
			} else {
				//Make them appear
				raycastArray.push(element);
				GsapAnimations.animateOpacity(element, 0, 1, true, false, true);
			}
		}
		hotspotsVisible = !hotspotsVisible;
		ele.classList.toggle("active");

		if (ele.classList.contains("active")) {
			GsapAnimations.animateToggleSize(ele, false);
		} else {
			GsapAnimations.animateToggleSize(ele, true);
		}
	},
};

/**
 * DOM Functions
 */

// let splide = new Splide(".splide", {
// 	type: "loop",
// 	perPage: 3,
// 	perMove: 1,
// 	focus: "center",
// });
// splide.mount();

function startAr(params) {
	arBtn = document.querySelector("#arBtn");
	arBtn.click();
}

const LoadDataFromConfig = {
	/**
	 * Initializing the config functions
	 */
	initConfig: function initConfig() {
		LoadDataFromConfig.loadOrbitControls();
		LoadDataFromConfig.loadSceneLights();
		LoadDataFromConfig.loadHeroProduct();
		LoadDataFromConfig.domElements();
		document.body.style.backgroundColor =
			CONFIGDATA.sceneBackground.color.colour;
		tick();
	},

	/**
	 * Loading data of config file
	 */
	initConfigData: function initConfigData() {
		LoadDataFromConfig.loadColourData();
		LoadDataFromConfig.loadXRaYData();
	},

	/**
	 * Loading data of config file
	 */
	domElements: function domElements() {
		// const companyInfo = CONFIGDATA.companyInformation
		// const controlPanelDom = document.querySelector('#controlsPanel')
		// const companyLogoDom = document.querySelector('#companyLogo img')
		// controlPanelDom.style.background = companyInfo.colors[0]
		// controlPanelDom.style.color = companyInfo.colors[1]
		// controlPanelDom.style.borderColor = companyInfo.colors[1]
		// if(companyInfo.logo)
		// companyLogoDom.setAttribute('src', `./assets/${companyInfo.logo}`)
	},

	loadOrbitControls: function loadOrbitControls() {
		/**
		 * Orbit controls
		 */

		controls = new OrbitControls(camera, canvas);
		controls.enableDamping = true;
		controls.dampingFactor = 0.2;
		controls.zoomSpeed = 0.3;
		controls.rotateSpeed = 0.9;
		// controls.maxDistance = 3.56
		// controls.minDistance = 1.75
		controls.maxPolarAngle = 1.6;
		controls.enablePan = true;

		/**
		 * OrbitControls GUI
		 */
		// const orbitControlsGui = gui.addFolder( 'OrbitControls' );

		// orbitControlsGui.add(controls, 'enableDamping').name( 'Enable Damping' )
		// orbitControlsGui.add(controls, 'enablePan').name( 'Enable Pan' )
		// orbitControlsGui.add(controls, 'dampingFactor').name( 'Damping Factor' ).min(0).max(2).step(0.01)
		// orbitControlsGui.add(controls, 'zoomSpeed').name( 'Zoom Speed' ).min(0).max(2).step(0.01)
		// orbitControlsGui.add(controls, 'rotateSpeed').name( 'Rotate Speed' ).min(0).max(2).step(0.01)
		// orbitControlsGui.add(controls, 'maxDistance').name( 'Max Zoom Distance' ).min(0).max(20).step(0.02)
		// orbitControlsGui.add(controls, 'minDistance').name( 'Min Zoom Distance' ).min(0).max(20).step(0.02)
		// orbitControlsGui.add(controls, 'maxPolarAngle').name( 'Max Polar Angle' ).min(-3.14159).max(3.14159).step(0.01)
	},

	loadSceneLights: function loadSceneLights() {
		/**
		 * Lights
		 */

		// const lightControlsGui = gui.addFolder( 'Lights' );
		const sceneLightInfo = CONFIGDATA.lights;

		for (const light of sceneLightInfo) {
			if (light.lightType == "ambient") {
				const ambientLight = new THREE.AmbientLight(
					light.lightColor,
					light.lightIntensity
				);
				ambientLight.name = light.lightName;
				scene.add(ambientLight);

				// lightControlsGui.add(ambientLight, 'intensity').name( 'Ambient Light Intensity' ).min(0).max(5).step(0.02)
				// lightControlsGui.addColor(ambientLight, 'color').name('Ambient Light Colour')
			}

			if (light.lightType == "spotLight") {
				const spotLight = new THREE.SpotLight(light.lightColor);
				spotLight.position.set(
					light.lightPosition.x,
					light.lightPosition.y,
					light.lightPosition.z
				);
				spotLight.intensity = light.lightIntensity;
				scene.add(spotLight);

				spotLight.angle = light.lightAngle;
				spotLight.penumbra = light.lightPneumbra;
				spotLight.decay = light.lightDecay;

				if (!isMobile) {
					if (light.lightCastShadow) {
						spotLight.castShadow = light.lightCastShadow; // default false
						//Set up shadow properties for the light
						spotLight.shadow.mapSize.width = light.lightShadowMapSize; // default
						spotLight.shadow.mapSize.height = light.lightShadowMapSize; // default
						spotLight.shadow.camera.near = 0.5; // default
						spotLight.shadow.camera.far = 500; // default
					}
				}
				spotLight.name = light.lightName;
				if (light.lightTarget) {
					const targetObject = new THREE.Object3D();
					targetObject.position.set(
						light.lightTarget.x,
						light.lightTarget.y,
						light.lightTarget.z
					);
					scene.add(targetObject);

					spotLight.target = targetObject;
				}
				// const spotLightHelper = new THREE.SpotLightHelper( spotLight );
				// scene.add( spotLightHelper );

				// lightControlsGui.addColor(spotLight, 'color').name(light.lightName+' Colour')
				// lightControlsGui.add(spotLight, 'intensity').name( light.lightName+' Intensity' ).min(0).max(200).step(1)
				// lightControlsGui.add(spotLight.position, 'x').name( light.lightName+' PositionX' ).min(-50).max(50).step(0.02)
				// lightControlsGui.add(spotLight.position, 'y').name( light.lightName+' PositionY' ).min(-50).max(50).step(0.02)
				// lightControlsGui.add(spotLight.position, 'z').name( light.lightName+' PositionZ' ).min(-50).max(50).step(0.02)
				// lightControlsGui.add(spotLight, 'angle').name( light.lightName+' Angle' ).min(-3.14159).max(3.14159).step(0.01)
				// lightControlsGui.add(spotLight, 'penumbra').name( light.lightName+' Penumbra' ).min(0).max(2).step(.01)
				// lightControlsGui.add(spotLight, 'decay').name( light.lightName+' Decay' ).min(0).max(20).step(.01)
			}

			if (light.lightType == "directionalLight") {
				const color = Number(light.lightColor);
				const directionalLight = new THREE.DirectionalLight(
					color,
					light.lightIntensity
				);
				directionalLight.name = light.lightName;
				directionalLight.position.set(
					light.lightPosition.x,
					light.lightPosition.y,
					light.lightPosition.z
				);

				if (!isMobile) directionalLight.castShadow = light.lightCastShadow;

				scene.add(directionalLight);
				// const helper = new THREE.DirectionalLightHelper( directionalLight, 2 );
				// scene.add( helper );
			}
		}
	},

	loadBackgroundModel: function loadBackgroundModel(
		modelPath,
		modelName,
		modelPosition,
		modelScale,
		modelRotation
	) {
		/**
		 * Hero Product
		 */

		const gltfLoader = new GLTFLoader();
		gltfLoader.load(
			// './WilliamsFW14B_update_06.glb',
			`${modelPath}${modelName}`,
			(gltf) => {
				if (!isMobile) {
					gltf.scene.traverse(function (child) {
						if (child instanceof THREE.Mesh) {
							child.receiveShadow = true;
						}
					});
				}

				gltf.scene.scale.set(modelScale.x, modelScale.y, modelScale.z);

				gltf.scene.position.set(
					modelPosition.x,
					modelPosition.y,
					modelPosition.z
				);

				gltf.scene.rotation.set(
					modelRotation.x,
					modelRotation.y,
					modelRotation.z
				);

				scene.add(gltf.scene);

				/**
				 * Hero Product GUI
				 */
				// const backgroundModelGui = gui.addFolder( 'Background model' );

				// backgroundModelGui.add(gltf.scene.scale, 'x').name( 'Scale' ).min(0).max(1).step(0.00001)
				// .onChange(function (val) {
				//     gltf.scene.scale.y = val
				//     gltf.scene.scale.z = val
				// })
				modelsLoaded = true;
				// backgroundModelGui.add(gltf.scene.rotation, 'y').name( 'RotationY' ).min(-3.14159).max(3.14159).step(0.01)
				// backgroundModelGui.add(gltf.scene.rotation, 'z').name( 'RotationZ' ).min(-3.14159).max(3.14159).step(0.01)

				// backgroundModelGui.add(gltf.scene.position, 'x').name( 'PositionX' ).min(-4).max(4).step(0.01)
				// backgroundModelGui.add(gltf.scene.position, 'y').name( 'PositionY' ).min(-4).max(4).step(0.01)
				// backgroundModelGui.add(gltf.scene.position, 'z').name( 'PositionZ' ).min(-4).max(4).step(0.01)
			},
			(progress) => {
				modelsLoaded = false;
				// console.log('progress')
				// console.log(progress)
			},
			(error) => {
				console.log("error");
				console.log(error);
			}
		);

		// const fbxLoader = new FBXLoader()
		// fbxLoader.load(
		//     `${modelPath}${modelName}`,
		//     (object) => {

		//         object.traverse( function(child) {
		//             if (child instanceof THREE.Mesh) {
		//                 child.receiveShadow = true;
		//             }
		//         })

		//         object.scale.set(modelScale.x,modelScale.y,modelScale.z)

		//         object.position.set(modelPosition.x,modelPosition.y,modelPosition.z)

		//         object.rotation.set(modelRotation.x,modelRotation.y,modelRotation.z)

		//         scene.add(object)
		//     },
		//     (xhr) => {
		//         console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
		//     },
		//     (error) => {
		//         console.log(error)
		//     }
		// )
	},

	loadHeroProduct: function loadHeroProduct() {
		/**
		 * Hero Product
		 */

		const heroProductInfo = CONFIGDATA.heroProduct;
		const gltfLoader = new GLTFLoader();
		gltfLoader.load(
			// './WilliamsFW14B_update_06.glb',
			`${heroProductInfo.product3DModelPath}${heroProductInfo.product3DModelFileName}`,
			(gltf) => {
				modelsLoaded = true;
				if (!isMobile) {
					if (
						heroProductInfo.product3DModelCastShadow ||
						heroProductInfo.product3DModelRecieveShadow
					) {
						gltf.scene.traverse(function (child) {
							if (child instanceof THREE.Mesh) {
								if (heroProductInfo.product3DModelCastShadow)
									child.castShadow = true;

								if (heroProductInfo.product3DModelRecieveShadow)
									child.receiveShadow = true;
							}
						});
					}
				}

				gltf.scene.scale.set(
					heroProductInfo.product3DModelScale.x,
					heroProductInfo.product3DModelScale.y,
					heroProductInfo.product3DModelScale.z
				);

				gltf.scene.position.set(
					heroProductInfo.product3DModelPosition.x,
					heroProductInfo.product3DModelPosition.y,
					heroProductInfo.product3DModelPosition.z
				);

				gltf.scene.rotation.set(
					heroProductInfo.product3DModelRotation.x,
					heroProductInfo.product3DModelRotation.y,
					heroProductInfo.product3DModelRotation.z
				);

				heroProduct = gltf.scene;

				// shadow
				// const mesh = new THREE.Mesh(
				//     new THREE.PlaneGeometry( 0.655, 1.3 ),
				//     new THREE.MeshBasicMaterial( {
				//         map: shadow, blending: THREE.MultiplyBlending, toneMapped: false, transparent: true
				//     } )
				// );
				// mesh.rotation.x = - Math.PI / 2;
				// productGroup.add( mesh );

				productGroup.add(heroProduct);
				productGroup.position.y = 0.1;
				HOTSPOTS.createAnnotations();
				LoadDataFromConfig.initConfigData();
				LoadDataFromConfig.sceneConfigLoader();
				LoadDataFromConfig.loadProductTickerInfo();

				if (gltf.animations) {
					mixer = new THREE.AnimationMixer(gltf.scene);
					clips = gltf.animations;
				}

				/**
				 * Hero Product GUI
				 */
				// const heroProductGui = gui.addFolder( 'Hero Product' );

				// heroProductGui.add(heroProduct.scale, 'x').name( 'Scale' ).min(0).max(1).step(0.00001)
				// .onChange(function (val) {
				//     heroProduct.scale.y = val
				//     heroProduct.scale.z = val
				// })

				// heroProductGui.add(heroProduct.rotation, 'y').name( 'RotationY' ).min(-3.14159).max(3.14159).step(0.01)
				// heroProductGui.add(heroProduct.rotation, 'z').name( 'RotationZ' ).min(-3.14159).max(3.14159).step(0.01)

				// heroProductGui.add(heroProduct.position, 'x').name( 'PositionX' ).min(-2).max(2).step(0.01)
				// heroProductGui.add(heroProduct.position, 'y').name( 'PositionY' ).min(-2).max(2).step(0.01)
				// heroProductGui.add(heroProduct.position, 'z').name( 'PositionZ' ).min(-2).max(2).step(0.01)
				setTimeout(() => {
					clearInterval(loadingAnimInterval)
					document.getElementById('loader').classList.add('hide')
				}, 1000);
			},
			(progress) => {
				modelsLoaded = false;
				// console.log('progress')
				// console.log(progress)
			},
			(error) => {
				console.log("error");
				console.log(error);
			}
		);
	},

	animateHeroModel: function animateHeroModel(ele) {
		if (clips) {
			const clip = THREE.AnimationClip.findByName(clips, "Animation");
			const action = mixer.clipAction(clip);

			if (heroAnimationDirection == "forward") {
				action.reset();
				action.fadeIn(1);
				action.setLoop(THREE.LoopOnce);
				action.clampWhenFinished = true;
				action.timeScale = 1.2;
				action.play();
				isHeroAnimationPlaying = true;
				heroAnimationDirection = "backward";
				setTimeout(() => {
					action.paused = true;
					isHeroAnimationPlaying = false;
				}, action._clip.duration * 1050);
			} else {
				action.timeScale = -1.2;
				action.paused = false;
				isHeroAnimationPlaying = true;
				heroAnimationDirection = "forward";
				setTimeout(() => {
					isHeroAnimationPlaying = false;
				}, action._clip.duration * 1050);
			}
			ele.classList.toggle("active");

			if (ele.classList.contains("active")) {
				GsapAnimations.animateToggleSize(ele, false);
			} else {
				GsapAnimations.animateToggleSize(ele, true);
			}
		}
	},

	loadProductTickerInfo: function loadProductTickerInfo() {
		const tickerData = CONFIGDATA.heroProduct.productTickerInfo;
		const tickerEle = document.querySelector("#infoTicker .container");
		tickerEle.innerHTML = "";

		tickerData.forEach((ticker) => {
			const wrapperDiv = document.createElement("p");
			wrapperDiv.innerHTML = ticker;
			tickerEle.appendChild(wrapperDiv);
		});

		GsapAnimations.toggleTickerTimer();
	},

	introAnimationPlay: function introAnimation() {
		const introAnimationArray =
			CONFIGDATA.introAnimation.animationSequencePoints;

		// scene.backgroundBlurriness = 0.1

		const tlOpacity = gsap.timeline();
		tlOpacity.pause();

		const tl2 = gsap.timeline({
			repeat: 0,
			onStart: function () {
				canvas.classList.add("show");
			},
			onComplete: function () {
				controls.maxDistance = 3.56;
				controls.minDistance = 1.75;
				const tl3 = gsap.timeline({
					onUpdate: function () {
						controls.update();
					},
				});
				tl3
					.to(controls.target, {
						x: 0,
						y: 0,
						z: 0,
						duration: 2,
						ease: "power1.inOut",
					})
				if (window.innerWidth < 768) {

					tl3.to(
						camera.position,
						{
							x: -1.7,
							y: -2.25,
							z: -2.3,
							duration: 2,
							ease: "power1.inOut",
						},
						"-=2"
					);
				}else {
					tl3.to(
						camera.position,
						{
							x: -1.7,
							y: -1.55,
							z: -2.3,
							duration: 2,
							ease: "power1.inOut",
						},
						"-=2"
					);

				}

				modelViewer = document.querySelector("model-viewer");
				modelViewer.src = `${CONFIGDATA.heroProduct.product3DModelPath}${CONFIGDATA.heroProduct.product3DModelFileName}`;
			},
			onUpdate: function () {
				controls.target = new THREE.Vector3(camera.position.x, 0, 0);
				// camera.lookAt(camera.position.x, 0, 0)
				camera.updateProjectionMatrix();
				controls.update();
			},
		});

		introAnimationArray.forEach((element) => {
			tl2
				.fromTo(
					canvas,
					{
						opacity: 1,
					},
					{
						opacity: 0,
						duration: 0.4,
						ease: "power1.inOut",
					},
					"-=.4"
				)
				.fromTo(
					canvas,
					{
						opacity: 0,
					},
					{
						opacity: 1,
						duration: 0.4,
						delay: 1,
						ease: "power1.inOut",
					}
				)
				.fromTo(
					camera.position,
					{
						x: element.cameraStartPoint.x,
						y: element.cameraStartPoint.y,
						z: element.cameraStartPoint.z,
					},
					{
						x: element.cameraEndPoint.x,
						y: element.cameraEndPoint.y,
						z: element.cameraEndPoint.z,
						duration: element.duration,
						ease: element.easing,
					},
					"-=.5"
				);
		});
	},

	sceneConfigLoader: async function sceneConfigLoader() {
		const sceneBackgroundType =
			CONFIGDATA.sceneBackground.backgroundTypeSelection;
		const sceneEnvironment = CONFIGDATA.sceneEnvironment;
		const sceneFloor = CONFIGDATA.sceneFloor;

		//Scene environments

		if (sceneEnvironment.type == "Equirectangular") {
			const hdrLoader = new RGBELoader();
			const envMap = await hdrLoader.loadAsync(
				`${sceneEnvironment.equiMapPath}${sceneEnvironment.equiMapFileName}`
			);
			envMap.mapping = THREE.EquirectangularReflectionMapping;
			scene.environment = envMap;

			// let generator = new THREE.PMREMGenerator(renderer);

			// new RGBELoader().load(`${sceneEnvironment.equiMapPath}${sceneEnvironment.equiMapFileName}`, (hdrmap) => {
			//     // ...
			//     let envmap = generator.fromEquirectangular(hdrmap);
			//     scene.environment = envmap.texture

			// });
			if (sceneBackgroundType == "environment") {
				skybox = new GroundedSkybox(envMap, params.height, params.radiusSkybox);
				skybox.position.y = params.height - 1.5;
				scene.add(skybox);
			}
		}

		//Scene backgrounds

		const cubeTexture = CONFIGDATA.sceneBackground.cubeTexture;
		if (sceneBackgroundType == "cubeTexture") {
			scene.background = cubeTextureLoader
				.setPath("./cubeTextures/option2/")
				.load(cubeTexture.textures);
		}

		if (sceneBackgroundType == "color") {
			// scene.add( backgroundColorLayer );
			scene.background = new THREE.Color(
				CONFIGDATA.sceneBackground.color.colour
			).convertLinearToSRGB();
		}

		if (sceneBackgroundType == "model") {
			const modelInfo = CONFIGDATA.sceneBackground.model;

			this.loadBackgroundModel(
				modelInfo.modelPath,
				modelInfo.modelName,
				modelInfo.modelPosition,
				modelInfo.modelScale,
				modelInfo.modelRotation
			);
			floor.visible = false;
		}

		// Scene floor
		if (sceneFloor.type == "model") {
			const modelInfo = sceneFloor;

			this.loadBackgroundModel(
				modelInfo.modelPath,
				modelInfo.modelName,
				modelInfo.modelPosition,
				modelInfo.modelScale,
				modelInfo.modelRotation
			);
			floor.visible = false;
		}
		if (sceneFloor.type == "plane") {
			floorMaterial.color = new THREE.Color(sceneFloor.color);

			if (sceneFloor.alphaMap) {
				floorMaterial.transparent = sceneFloor.transparent;
				const alphaMap = textureLoader.load(sceneFloor.alphaMap);
				floorMaterial.alphaMap = alphaMap;
			}

			floor.position.set(
				sceneFloor.position.x,
				sceneFloor.position.y,
				sceneFloor.position.z
			);
			scene.add(floor);
		}

		const intervalMain = setInterval(() => {
			if (modelsLoaded) {
				setTimeout(() => {
					clearInterval(intervalMain);
					// LoadDataFromConfig.introAnimationPlay();
					canvas.classList.add("show");
					modelViewer = document.querySelector("model-viewer");
					modelViewer.src = `${CONFIGDATA.heroProduct.product3DModelPath}${CONFIGDATA.heroProduct.product3DModelFileName}`;
				}, 500);
			}
		}, 100);
	},

	loadColourData: function loadColourData() {
		const selectionOptions = document.createElement("div");
		selectionOptions.className = "selection-options";
		selectionOptions.id = "colours-selection";

		controlOptionsDiv.appendChild(selectionOptions);

		for (const colour of CONFIGDATA.controlPanel.coloursMain.colourOptions) {
			const colourOption = document.createElement("div");
			colourOption.className = "selectionItem color";
			colourOption.setAttribute("onclick", `switchColor('${colour}')`);
			colourOption.style.backgroundColor = `${colour}`;

			selectionOptions.appendChild(colourOption);
		}

		for (const material of CONFIGDATA.controlPanel.coloursMain.materials) {
			heroProduct.traverse(function (child) {
				if (child.material && child.material.name === material) {
					colorMat.push(child.material);
				}
			});
		}
	},
	loadXRaYData: function loadXRaYData() {
		for (const material of CONFIGDATA.controlPanel.xRay.materials) {
			heroProduct.traverse(function (child) {
				if (child.material && child.material.name === material) {
					xRayMats.push(child.material);
				}
			});
		}
	},
};

const ControlPanelFunctions = {
	toggleMainControls: function toggleMainControls(ele) {
		if (ele.classList.contains("active")) {
			GsapAnimations.animateControlPanelMain(ele, "reverse");
		} else {
			GsapAnimations.animateControlPanelMain(ele, "reverseAndShow");
		}
	},

	closeMainControls: function closeMainControls(ele) {
		const parentID = ele.getAttribute("data-parent");
		const parent = document.querySelector(parentID);
		if (parent.classList.contains("active")) {
			GsapAnimations.animateControlPanelMain(parent, "reverse");
		} else {
			GsapAnimations.animateControlPanelMain(parent, "reverseAndShow");
		}
	},

	controlOptionClickToggle: function controlOptionClickToggle(ele) {
		ele.classList.toggle("active");
		const childId = ele.getAttribute("data-child");
		document.querySelector(`#${childId}`).classList.toggle("active");
		if (ele.classList.contains("active")) {
			GsapAnimations.animateToggleSize(ele, false);
		} else {
			GsapAnimations.animateToggleSize(ele, true);
		}
	},

	hotspotOnClick: function hotspotOnClick(eleData, intersectionPoint) {
		const hotspotInfoContainer = document.querySelector(
			"#hotspotInfoContainer"
		);
		const headerDom = document.querySelector("#hotspotHeader");
		const descDom = document.querySelector("#hotspotDesc");
		const mediaDom = document.querySelector("#hotSpotMedia");

		headerDom.innerHTML = eleData.userData.name;
		descDom.innerHTML = eleData.userData.description;

		isThreeJsPointerEventsEnabled = false;
		GsapAnimations.animateCameraToPoint(eleData);
		setTimeout(() => {
			hotspotInfoContainer.classList.toggle("show");
		}, 2000);
	},

	hotspotInfoClose: function hotspotInfoClose() {
		const hotspotInfoContainer = document.querySelector(
			"#hotspotInfoContainer"
		);
		hotspotInfoContainer.classList.remove("show");
		isThreeJsPointerEventsEnabled = true;
	},

	xRayToggle: function xRayToggle(ele) {
		isXRayOn = !isXRayOn;
		functionLibrary.xRayAnimation(xRayMats, THREE, gsap, isXRayOn);
		ele.classList.toggle("active");

		if (ele.classList.contains("active")) {
			GsapAnimations.animateToggleSize(ele, false);
		} else {
			GsapAnimations.animateToggleSize(ele, true);
		}
	},

	switchColor: function switchColor(color) {
		colorMat.forEach((material) => {
			if (material)
				functionLibrary.changeBodyColourMatName(material, color, THREE, gsap);
		});
	},
};

function toggleMobileOptions() {

	if (window.innerWidth < 768) {
		controlsPanel.classList.remove('show')
		document.querySelector("#productSelector").classList.remove("show");
	}
}

function closeLeadGenFormFunct() {
	document.querySelector("#leadGeneration").classList.add("hide");
	controlsPanel.classList.add("show");
	// setTimeout(() => {
	// 	toggleMobileOptions()
	// }, 3000);
}

function bookNowFunct() {
	toggleProductInfoFunct()
	setTimeout(() => {
		controlsPanel.classList.remove("show");
		document.querySelector("#leadGeneration").classList.remove("hide");
	}, 500);
}

function toggleControlsPanel() {
	const ele = document.getElementById('productConfiguratorMobile')
	ele.classList.toggle("active");
	controlsPanel.classList.toggle("show");
}

function toggleProductSelector() {
	const ele = document.getElementById('productToggleMobile')
	ele.classList.toggle("active");
	document.querySelector("#productSelector").classList.toggle("show");
}

function toggleProductInfoFunct() {
	document.querySelector("#productData").classList.toggle("show");
	const ele = document.getElementById('brochure-btn')
	ele.classList.toggle("active");

	if (ele.classList.contains("active")) {
		GsapAnimations.animateToggleSize(ele, false);
	} else {
		GsapAnimations.animateToggleSize(ele, true);
	}
}

function toggleQrDisplay() {
	document.querySelector("#qrImg").classList.toggle("show");
	const ele = document.getElementById('qrIcon')
	// const ele1 = document.getElementById('qrIconMobile')
	ele.classList.toggle("active");
	// ele1.classList.toggle("active");

}

const questionContainer = document.querySelector("#questionContainer");
const questionClose = document.querySelector("#questionContainer #close");

setTimeout(() => {
	// questionContainer.classList.add('active')
}, 26000);

questionClose.addEventListener("click", function () {
	questionContainer.classList.remove("active");
});

/**
 * Event listners
 */

window.addEventListener("pointerdown", onPointerDown);
window.addEventListener("pointermove", onPointerMove);
window.addEventListener("pointerup", onPointerUp);
closeLeadGenForm.addEventListener("click", closeLeadGenFormFunct);
closeProductDataModal.addEventListener("click", toggleProductInfoFunct);
document.getElementById('qrIcon').addEventListener("click", toggleQrDisplay);
// document.getElementById('qrIconMobile').addEventListener("click", toggleQrDisplay);

// Functions to DOM
window.animateHeroModel = LoadDataFromConfig.animateHeroModel;
window.startAr = startAr;
window.toggleHotspots = HOTSPOTS.toggleHotspots;
window.hotspotInfoClose = ControlPanelFunctions.hotspotInfoClose;
window.toggleMainControls = ControlPanelFunctions.toggleMainControls;
window.closeMainControls = ControlPanelFunctions.closeMainControls;
window.xRayToggle = ControlPanelFunctions.xRayToggle;
window.controlOptionClickToggle =
	ControlPanelFunctions.controlOptionClickToggle;
window.switchColor = ControlPanelFunctions.switchColor;
window.toggleProductInfoFunct = toggleProductInfoFunct;
window.toggleQrDisplay = toggleQrDisplay;
window.bookNowFunct = bookNowFunct;
window.toggleControlsPanel = toggleControlsPanel;
window.toggleProductSelector = toggleProductSelector;


LoadDataFromConfig.initConfig();
